import React, { useState, useEffect } from 'react';
import axios from 'axios';
import animateScrollTo from 'animated-scroll-to';

import GoogleMap from './maps/GoogleMap/index.js';

import FilteredPostcards from './FilteredCards';
import PostcardDetail from './bars/PostcardDetail';

const LocationMap = ({ page, newPage, height, t }) => {
  const [initialized, setInitialized] = useState(false);
  const [cardId, setCardId] = useState(null);
  const [cards, setCards] = useState([]);
  const [cardIds, setCardIds] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [markers, setMarkers] = useState([]);

  // /////// CONSTANTS:
  const service = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`
  });

  const getCards = () => {
    if (!cardIds) return;
    service
      .post('/postcard/many', { ids: cardIds })
      .then(cards => {
        setInitialized(true);
        setCards(cards.data);
      })
      .catch(error => console.log(error));
  };
  useEffect(() => {
    newPage();
    animateScrollTo(0);
    service
      .get('/postcard/markers')
      .then(res => setMarkers(res.data))
      .catch(error => console.log(error));
  }, []);

  useEffect(() => {
    setCardId(null);
    getCards();
    if (cardIds) {
      animateScrollTo(height);
    }
  }, [cardIds]);

  return (
    <section>
      <GoogleMap locations={markers} setCardId={setCardId} setCardIds={setCardIds} />
      <FilteredPostcards
        initialLoad={initialized}
        getCards={getCards}
        cards={cards}
        setSelectedCard={setSelectedCard}
        initialized={initialized}
        limit={false}
        cardId={cardId}
        t={t}
      >
        {cardId && (
          <PostcardDetail
            setSelectedCard={setSelectedCard}
            card={selectedCard}
            cardId={cardId}
            key={cardId}
            page={page}
            height={height}
          />
        )}
      </FilteredPostcards>
    </section>
  );
};

export default LocationMap;
